<template>
  <LinkChain
    v-if="entry.type === 'link_chain'"
    ref="el"
    :linkChain="entry"
    class="touch-callout-none mt-2 text-xs"
  />
  <EntryLink
    v-else
    ref="el"
    class="touch-callout-none inline-block h-4 w-4 rounded-sm hover:bg-lexmea-gray-600 hover:ring-4 hover:ring-lexmea-gray-600 active:outline-none"
    :entry="entry"
    :title="entry.title"
  >
    <SchemaIcon
      v-if="entry.type === 'schema'"
      class="touch-callout-none h-full w-full"
      :filled="currentlyActive"
      :colorClass="colorFromEntry(entry)"
      :focus="currentlyActive"
      :sharedInChannel="entry.is_shared"
      :channelColor="entry.channel_color"
    />
    <PaperIcon
      v-else-if="entry.type === 'note'"
      class="touch-callout-none h-full w-full"
      filled
      :colorClass="colorFromEntry(entry)"
      :focus="currentlyActive"
    />
  </EntryLink>
</template>

<script lang="ts" setup>
import type { ILinkChain, INote, ISchema } from "~/models/IUserEntry";

const props = defineProps<{
  entry: ISchema | INote | ILinkChain;
}>();

const emit = defineEmits<{
  contextmenu: [MouseEvent];
}>();

const { isActive } = useActiveEntryRouteParams();
const { colorFromEntry } = useColorFromEntry();

const currentlyActive = computed(() => isActive(props.entry));

const el = ref();
const contextMenuHandler = (e?: MouseEvent) => {
  if (!e) return;
  e.preventDefault();
  e.stopPropagation();
  emit("contextmenu", e);
};

useLongClick(el, contextMenuHandler);
</script>

<style scoped>
.touch-callout-none {
  -webkit-touch-callout: none;
}
</style>
